import { LOCATION_CHANGE } from 'connected-react-router';

import {
  ADD_ORGANIZATIONS_START,
  ADD_ORGANIZATIONS_SUCCESS,
  ADD_ORGANIZATIONS_ERROR,
  SHOW_ORGANIZATION_START,
  SHOW_ORGANIZATION_SUCCESS,
  SHOW_ORGANIZATION_ERROR,
  CREATE_ORGANIZATION_START,
  CREATE_ORGANIZATION_SUCCESS,
  CREATE_ORGANIZATION_ERROR,
  UPDATE_ORGANIZATION_START,
  UPDATE_ORGANIZATION_SUCCESS,
  UPDATE_ORGANIZATION_ERROR,
} from '../constants/Organization';

const defaultState = {
  path: null,

  item: {},
  itemLoading: false,
  itemFetched: false,

  items: [],
  itemsFetched: false,
  itemsLoading: false,
  meta: { page: 1, pageSize: 10 },

  errorMessage: null,
};

export default function OrganizationReducer(
  state = defaultState,
  { type, payload, items, meta, errorMessage, item }
) {
  switch (type) {
    case LOCATION_CHANGE:
      return { ...state, successMessage: null, errorMessage: null, errors: {} };

    case ADD_ORGANIZATIONS_START:
      return {
        ...state,
        itemsLoading: true,
        itemsFetched: false,
      };

    case ADD_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        itemsLoading: false,
        errorMessage: null,
        itemsFetched: true,
        items,
        meta,
      };

    case ADD_ORGANIZATIONS_ERROR:
      return {
        ...state,
        itemsLoading: false,
        itemsFetched: false,
        errorMessage,
      };

    case SHOW_ORGANIZATION_START:
      return {
        ...state,
        itemLoading: true,
        itemFetched: false,
      };

    case SHOW_ORGANIZATION_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        itemFetched: true,
        errorMessage: null,
        item,
      };

    case SHOW_ORGANIZATION_ERROR:
      return {
        ...state,
        itemLoading: false,
        itemFetched: false,
        errorMessage,
      };

    case CREATE_ORGANIZATION_START:
      return {
        ...state,
        itemLoading: true,
      };

    case CREATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        errorMessage: null,
        item,
      };

    case CREATE_ORGANIZATION_ERROR:
      return {
        ...state,
        itemLoading: false,
        errorMessage,
      };

    case UPDATE_ORGANIZATION_START:
      return {
        ...state,
        itemLoading: true,
      };

    case UPDATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        errorMessage: null,
        item,
      };

    case UPDATE_ORGANIZATION_ERROR:
      return {
        ...state,
        itemLoading: false,
        errorMessage,
      };

    default:
      return state;
  }
}
